"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const constants_1 = require("modules/app/services/datahub/constants");
const DatahubService_1 = __importDefault(require("modules/app/services/datahub/DatahubService"));
const helper_1 = require("modules/app/services/datahub/helper");
const DatahubClassTypes_1 = require("./DatahubClassTypes");
class DatahubClassService {
    constructor() {
        this.sendClassTabGroupViewEvent = ({ category, classId }) => {
            const label = `${DatahubClassTypes_1.ClassLabel.ClassId}=${classId}`;
            this.sendInteractionClickEvent(category, label);
        };
        this.sendDeleteClassEvent = ({ category, classId }) => {
            const label = `${DatahubClassTypes_1.ClassLabel.ClassId}=${classId}`;
            this.sendInteractionClickEvent(category, label);
        };
        this.sendCreateNewOfferEvent = (classId) => {
            const label = classId !== null && classId !== void 0 ? classId : '';
            this.sendInteractionClickEvent(DatahubClassTypes_1.ClassCategory.ClickCreateNewOfferButton, label);
        };
        this.sendSelectClassModuleEvent = ({ category, classId }) => {
            const label = `${DatahubClassTypes_1.ClassLabel.ClassId}=${classId}`;
            this.sendInteractionClickEvent(category, label);
        };
        this.sendSaveClassEvent = ({ isNew = false, newClassReferrer = '' }) => {
            const category = isNew
                ? DatahubClassTypes_1.ClassCategory.CreateClass
                : DatahubClassTypes_1.ClassCategory.UpdateClass;
            this.sendInteractionClickEvent(category, newClassReferrer);
        };
        this.sendSaveClassModuleEvent = ({ isExtraModule = false, classId }) => {
            const label = `${DatahubClassTypes_1.ClassLabel.ClassId}=${classId}`;
            const category = isExtraModule
                ? DatahubClassTypes_1.ClassCategory.SaveExtraClassModule
                : DatahubClassTypes_1.ClassCategory.SaveMainClassModule;
            this.sendInteractionClickEvent(category, label);
        };
        this.sendClassSearchEvent = (hasResults) => {
            const { SEARCH_RESULTS, NO_SEARCH_RESULTS } = constants_1.EVENTS_LABELS.CLASS;
            const label = hasResults ? SEARCH_RESULTS : NO_SEARCH_RESULTS;
            DatahubService_1.default.sendEvent({
                action: constants_1.EVENT_ACTIONS.INTERACT,
                event: (0, helper_1.buildInteractionEventData)({
                    category: constants_1.EVENTS_CATEGORY.CLASS.CLASS_SEARCH,
                    action: constants_1.EVENTS_INTERACTIONS.SHOW,
                    label
                })
            });
        };
    }
    sendInteractionClickEvent(category, label = '') {
        DatahubService_1.default.sendEvent({
            action: constants_1.EVENT_ACTIONS.INTERACT,
            event: (0, helper_1.buildInteractionEventData)({
                category,
                action: constants_1.EVENTS_INTERACTIONS.CLICK,
                label
            })
        });
    }
}
exports.default = new DatahubClassService();
